module.exports = __webpack_public_path__ + "static/media/guarantee-product-6.ed56561b.png";